import Tippy from '@tippyjs/react';

import { cn, groupAndSort, snakeToTitleCase } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';
import Divider from 'components/shared/Divider/Divider';

import { getFirstName, getLastName } from '../lib/getName';

const AllAvatars = ({
  items,
  size,
  fontSize,
  itemSize,
  itemsToShow = 4,
  placement,
  itemsGroupBy,
  itemsGroupLabelClassName,
  isDisabled,
  onShow,
  onHide
}) => {
  const remainingCount = items.length - itemsToShow;

  if (remainingCount <= 0) return null;

  const groupedItems = groupAndSort(items, itemsGroupBy);

  return (
    <Tippy
      className="custom-tooltip w-max max-w-[300px] py-2"
      animation="fade"
      interactive={true}
      trigger="click"
      arrow={false}
      placement={placement}
      onShow={onShow}
      onHide={onHide}
      disabled={isDisabled}
      appendTo={() => document.body}
      content={
        <div className="flex max-h-[400px] flex-col gap-1 overflow-y-auto">
          {groupedItems.map(([groupName, groupItems], groupIndex) => (
            <div key={groupName || groupIndex} className="flex flex-col gap-1">
              {itemsGroupBy && groupIndex > 0 && <Divider className="my-1" />}
              {itemsGroupBy && (
                <span
                  className={cn(
                    'px-4 py-1 text-xs font-600 leading-[14px] text-neutral-900',
                    itemsGroupLabelClassName
                  )}>
                  {snakeToTitleCase(groupName)}
                </span>
              )}
              {groupItems.map((item, index) => (
                <div key={index} className="flex select-none items-center gap-2 px-4 py-1">
                  <Avatar
                    size="medium"
                    fontSize="text-[10px]"
                    firstName={getFirstName(item)}
                    lastName={getLastName(item)}
                    image={item.image}
                    id={item.id}
                  />
                  <div className="flex flex-col overflow-hidden">
                    <span
                      className="line-clamp-1 text-sm leading-4 text-neutral-900"
                      title={`${getFirstName(item)} ${getLastName(item)}`}>
                      {getFirstName(item)} {getLastName(item)}
                    </span>
                    <p
                      className="line-clamp-2 text-xs font-400 leading-[14px] text-neutral-700"
                      title={item.description}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      }>
      <div
        className={cn(
          'flex items-center justify-center rounded-full',
          size === 'small' || size === 'medium' ? 'ml-1' : 'ml-[6px]',
          !isDisabled && 'cursor-pointer'
        )}
        style={{
          width: itemSize,
          height: itemSize,
          zIndex: itemsToShow + 1
        }}>
        <span
          className={cn(
            'flex items-center font-500',
            isDisabled ? 'text-neutral-400' : 'text-neutral-700',
            fontSize
          )}>
          <span className="mb-[2px] leading-3 ">+</span>
          <span>{remainingCount}</span>
        </span>
      </div>
    </Tippy>
  );
};

export default AllAvatars;
